import style from "./Input.module.css"

function Input(props){

    return (
        <div>
            {/* aria-label fornisce il nome accessibile del campo (WCAG 1.3.1 / 3.3.2):
                l'etichetta visibile e' uno <span> adiacente non associato
                programmaticamente e il placeholder scompare alla digitazione.
                Attributi ARIA: nessun impatto sulla resa grafica. */}
            <input
                className={props.errorClause? style.errorBorder:style.txtInput}
                type={props.type?props.type:"text"}
                placeholder={props.placeholder}
                id={props.id}
                aria-label={props.ariaLabel}
                aria-invalid={props.errorClause ? "true" : undefined}
                aria-describedby={props.errorClause ? `${props.id}-errore` : undefined}
                value={props.value}
                onChange={props.onChange}
                disabled={props.disabled}
                style={props.style}
            />
            <div>
                {/* Il messaggio d'errore era reso con <label htmlFor>, che ne faceva
                    il nome accessibile del campo al posto dell'etichetta (WCAG 3.3.1).
                    Ora e' uno <span> collegato con aria-describedby; role="alert" lo fa
                    annunciare alla comparsa (e' reso solo quando errorClause e' vero). */}
                {props.errorClause?<span id={`${props.id}-errore`} role="alert" className={style.errorMessage}>{props.errorMessage}</span>:null}
            </div>
        </div>

    )
}
export default Input